import {v4 as uuidv4} from 'uuid';
import {TodayGiftDto} from '../../common/shared/api/nicolas/vo/TodayGiftDto.interface';
import {getTicketExpiredText} from '../../common/shared/utils/getTicketExpiredText';
import {TodayGift} from '../generated/types';
import {createTicketKind} from './TicketKind';
import {createTicketType} from './TicketType';

export function createTodayGift({
  is_received,
  ticket_count,
  ticket_type,
  today_gift_uid,
  ticket_expire_at,
}: TodayGiftDto): TodayGift {
  return {
    id: uuidv4(),
    ticketCount: ticket_count,
    ticketType: createTicketType(ticket_type),
    ticketKind: createTicketKind(ticket_type),
    uid: today_gift_uid,
    ticketExpireAt: ticket_expire_at,
    ticketExpiredText: getTicketExpiredText(ticket_expire_at),
    isReceived: is_received,
  };
}
